import { ClientShipmentFolder } from "@redotech/redo-model/views/folders";
import { ClientShipmentView } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getShipmentViewsAndFolders = {
  name: "getShipmentViewsAndFolders" as const,
  input: z.null(),
  output: z.object({
    folders: z.array(ClientShipmentFolder),
    views: z.array(ClientShipmentView),
  }),
};
